"use client";

import type { QuoteLayoutConfig } from "@/@sdk/brands/brand-model";
import { cn } from "@/lib/utils";

const LAYOUT_OPTIONS: {
  value: QuoteLayoutConfig;
  label: string;
  description: string;
}[] = [
  {
    value: "CONFIG_A",
    label: "Configuration A",
    description: "Standard vertical flow",
  },
  {
    value: "CONFIG_B",
    label: "Configuration B",
    description: "Sidebar summary with main content",
  },
  {
    value: "CONFIG_C",
    label: "Configuration C",
    description: "Magazine hero with 35/65 pricing columns",
  },
];

function LayoutWireframe({ layout }: { layout: QuoteLayoutConfig }) {
  if (layout === "CONFIG_B") {
    return (
      <div className="grid grid-cols-[1fr_2fr] gap-2 p-2">
        <div className="space-y-2">
          <div className="h-16 rounded-md bg-muted" />
          <div className="h-10 rounded-md border bg-white" />
        </div>
        <div className="space-y-2">
          <div className="h-8 rounded-md bg-muted" />
          <div className="h-14 rounded-md border bg-white" />
        </div>
      </div>
    );
  }

  if (layout === "CONFIG_C") {
    return (
      <div className="space-y-2 p-2">
        <div className="h-10 rounded-md bg-muted" />
        <div className="h-6 rounded bg-muted/60" />
        <div className="h-12 rounded-md border bg-white" />
        <div className="grid grid-cols-[7fr_13fr] gap-2">
          <div className="h-8 rounded-md border bg-white" />
          <div className="h-8 rounded-md border bg-white" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2 p-2">
      <div className="h-10 rounded-md bg-muted" />
      <div className="h-8 rounded-md border bg-white" />
      <div className="h-12 rounded-md border bg-white" />
      <div className="grid grid-cols-2 gap-2">
        <div className="h-8 rounded-md border bg-white" />
        <div className="h-8 rounded-md border bg-white" />
      </div>
    </div>
  );
}

export function LayoutConfigPicker({
  value,
  onChange,
}: {
  value: QuoteLayoutConfig;
  onChange: (value: QuoteLayoutConfig) => void;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {LAYOUT_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-lg border text-left transition-colors hover:bg-muted/50",
            value === option.value && "border-primary ring-1 ring-primary"
          )}
        >
          <LayoutWireframe layout={option.value} />
          <div className="border-t px-3 py-2">
            <p className="text-sm font-medium">{option.label}</p>
            <p className="text-xs text-muted-foreground">{option.description}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
